import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["aria-label"];
import SvgIcon from "@/common/components/SvgIcon.vue";
import { useDateTimeFormat } from "@/common/composables/date-time-format";
import { vTooltip } from "@/common/directives/tip-directive";
import { computed, inject, onMounted } from "vue";
const secondThreshold = 90;
const minuteSeconds = 60;
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecorderDuration',
    props: {
        maximum: {},
        minimum: {},
        atMax: { type: Boolean },
        belowMin: { type: Boolean },
        recordedSeconds: {},
        playbackSeconds: {},
        playback: { type: Boolean },
        isRecordingPaused: { type: Boolean }
    },
    emits: ["pass-limit-message"],
    setup(__props, { emit: __emit }) {
        const i18n = inject("i18n");
        const props = __props;
        const dateFormat = useDateTimeFormat();
        const timer = computed(() => dateFormat.timerFormat(props.playback
            ? props.playbackSeconds
            : props.maximum > 0 && props.minimum < 1
                ? Math.max(props.maximum - props.recordedSeconds, 0)
                : props.recordedSeconds));
        const getDuration = (seconds) => {
            return seconds <= secondThreshold ? i18n.t("{0}s", [seconds]) : i18n.t("{0}m", [seconds / minuteSeconds]);
        };
        const labelShort = computed(() => {
            if (props.maximum > 0 && props.minimum > 0) {
                return `${getDuration(props.minimum)}-${getDuration(props.maximum)}`;
            }
            else if (props.maximum > 0) {
                return `< ${getDuration(props.maximum)}`;
            }
            else if (props.minimum > 0) {
                return `> ${getDuration(props.minimum)}`;
            }
            else {
                return "";
            }
        });
        const labelFull = computed(() => {
            if (props.maximum > 0 && props.minimum > 0) {
                // Minimum and maximum set
                let limitString = "<strong>" + i18n.t("Limit") + ":</strong> ";
                if (props.minimum > secondThreshold && props.maximum > secondThreshold) {
                    limitString += i18n.t("{0} to {1} minutes", [props.minimum / minuteSeconds, props.maximum / minuteSeconds]);
                }
                else if (props.minimum <= secondThreshold && props.maximum <= secondThreshold) {
                    limitString += i18n.t("{0} to {1} seconds", [props.minimum, props.maximum]);
                }
                else {
                    limitString += i18n.t("{0} seconds to {1} minutes", [props.minimum, props.maximum / minuteSeconds]);
                }
                return limitString;
            }
            else if (props.maximum > 0) {
                // Only maximum set
                return ("<strong>" +
                    i18n.t("Maximum") +
                    ":</strong> " +
                    (props.maximum > secondThreshold
                        ? i18n.t("{0} minutes", [props.maximum / minuteSeconds])
                        : i18n.t("{0} seconds", [props.maximum])));
            }
            else if (props.minimum > 0) {
                // Only minimum set
                return ("<strong>" +
                    i18n.t("Minimum") +
                    ":</strong> " +
                    (props.minimum > secondThreshold
                        ? i18n.t("{0} minutes", [props.minimum / minuteSeconds])
                        : i18n.t("{0} seconds", [props.minimum])));
            }
            return "";
        });
        // If within 10% or less than 10 seconds of the duration limit
        const isApproachingMaximum = computed(() => props.maximum > 0 && props.recordedSeconds > Math.min(props.maximum - 10, props.maximum * 0.9));
        const limitWarning = computed(() => !props.playback && (props.belowMin || isApproachingMaximum.value));
        const limitInvalid = computed(() => !props.playback && (props.atMax || (props.isRecordingPaused && props.belowMin)));
        const emits = __emit;
        onMounted(() => {
            emits("pass-limit-message", labelFull.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.maximum > 0 || __props.minimum > 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["rec-recorder-limit", { 'rec-recorder-limit--warning': limitWarning.value }]),
                        "aria-label": labelFull.value
                    }, [
                        _createVNode(SvgIcon, {
                            icon: "icon-clock-duration",
                            width: "1.25rem",
                            height: "1.25rem"
                        }),
                        _createTextVNode(" " + _toDisplayString(labelShort.value), 1)
                    ], 10, _hoisted_1)), [
                        [
                            _unref(vTooltip),
                            labelFull.value,
                            void 0,
                            { touch: true }
                        ]
                    ])
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["rec-recorder-timer", {
                            'rec-recorder-timer--warning': limitWarning.value,
                            'rec-recorder-timer--danger': limitInvalid.value
                        }])
                }, _toDisplayString(timer.value), 3)
            ], 64));
        };
    }
});
